export default "\r\n<div [id]=\"chartID\" [ngStyle]=\"chartStyle\"></div>";